import Vue from 'vue';
import Meta from 'vue-meta';
import vuei18n from '@/locales/i18n';
import store from '@/store/store';
import Tags from '@/views/Tags';
import Essentials from '@/views/Essentials';
import Collection from '@/views/Collection';
import Style from '@/views/Style';
import AssignProduct from '@/views/AssignProduct';
import AddPet from '@/views/AddPet';

import VueRouter from 'vue-router';
import CollarStyle from '@/views/Collars&Leashes/CollarStyle';
import LeashStyle from '@/views/Collars&Leashes/LeashStyle';
import EssentialStyle from '@/views/EssentialStyle';
import WalletCardStyle from '@/views/WalletCardStyle';
import Collars from '@/views/Collars&Leashes/Collars';
import WalletCard from '@/views/WalletCards';
import ProductInterrupt from '@/views/ProductInterrupt';
import Homepage from '@/views/Homepage';
import WalletCardProduct from '@/views/WalletCardProduct';
import AddToOrder from '@/views/AddToOrder.vue';

Vue.use(VueRouter);
Vue.use(Meta, {
  keyName: 'metaTag',
  refreshOnceOnNavigation: true,
});

const routes = [
  {
    path: '',
    name: 'Store',
    component: Homepage,
    meta: {
      title: 'DocuPet Store - Pet ID Tags, Pet Trackers, Collars, Leashes, Wallet Cards and Pet Essentials',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Free shipping on our wide selection of personalized custom pet ID tags for dogs and cats, pet trackers, wallet cards, collars, leashes and other pet essential products. 20% of every tag purchase is donated to local animal shelters.',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'DocuPet Store - Pet ID Tags, Pet Trackers, Collars, Leashes, Wallet Cards and Pet Essentials',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            'Free shipping on our wide selection of personalized custom pet ID tags for dogs and cats, pet trackers, wallet cards, collars, leashes and other pet essential products. 20% of every tag purchase is donated to local animal shelters.',
        },
      ],
    },
  },
  {
    path: '/tags',
    name: 'TagStore',
    component: Tags,
    meta: {
      title: 'Custom Pet ID Tags, Personalized for Dogs & Cats - DocuPet',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Free shipping on our wide selection of personalized pet ID tags for dogs and cats. 20% of every tag purchase is donated to local animal shelters.',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Custom Pet ID Tags, Personalized for Dogs & Cats - DocuPet',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            'Free shipping on our wide selection of personalized pet ID tags for dogs and cats. 20% of every tag purchase is donated to local animal shelters.',
        },
      ],
    },
    props: {
      showAllTags: true,
    },
  },
  {
    path: '/essentials',
    name: 'EssentialsStore',
    component: Essentials,
    meta: {
      title: 'Essential products for Dogs & Cats - DocuPet',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Safety products, grooming & clean-up products, feeding products and toys for pets. Every purchase supports shelter animals.',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Essential products for Dogs & Cats - DocuPet',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            'Safety products, grooming & clean-up products, feeding products and toys for pets. Every purchase supports shelter animals.',
        },
      ],
    },
  },
  {
    path: '/essentials/all',
    name: 'EssentialsStoreAll',
    component: Essentials,
    props: {
      showAllProducts: true,
    },
    meta: {
      title: 'Essential products for Dogs & Cats - DocuPet',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Safety products, grooming & clean-up products, feeding products and toys for pets. Every purchase supports shelter animals.',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Essential products for Dogs & Cats - DocuPet',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            'Safety products, grooming & clean-up products, feeding products and toys for pets. Every purchase supports shelter animals.',
        },
      ],
    },
  },
  {
    path: '/collars',
    name: 'CollarStore',
    component: Collars,
    meta: {
      title: 'Personalized Collars and Leashes for Dogs & Cats - DocuPet',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Free shipping on our wide selection of personalized collars and leashes for dogs and cats. 20% of every collar and leash purchase is donated to local animal shelters.',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Personalized Collars and Leashes for Dogs & Cats - DocuPet',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            'Free shipping on our wide selection of personalized collars and leashes for dogs and cats. 20% of every collar and leash purchase is donated to local animal shelters.',
        },
      ],
    },
  },
  {
    path: '/leashes',
    name: 'LeashStore',
    redirect: { name: 'CollarStore' },
  },
  {
    path: '/tags/pet/:petId',
    name: 'StoreForPet',
    component: Tags,
    props: true,
    meta: {
      title: 'Custom Pet ID Tags, Personalized for Dogs & Cats - DocuPet',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Free shipping on our wide selection of personalized pet ID tags for dogs and cats. 20% of every tag purchase is donated to local animal shelters.',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Custom Pet ID Tags, Personalized for Dogs & Cats - DocuPet',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            'Free shipping on our wide selection of personalized pet ID tags for dogs and cats. 20% of every tag purchase is donated to local animal shelters.',
        },
      ],
    },
  },
  {
    path: '/tags/style/all',
    alias: ['/tags/styles', '/tags/styles/all'],
    name: 'Tags',
    component: Tags,
    props: {
      showAllTags: true,
    },
    meta: {
      title: 'Custom Pet ID Tags, Personalized for Dogs & Cats - DocuPet',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Free shipping on our wide selection of personalized pet ID tags for dogs and cats. 20% of every tag purchase is donated to local animal shelters.',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Custom Pet ID Tags, Personalized for Dogs & Cats - DocuPet',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            'Free shipping on our wide selection of personalized pet ID tags for dogs and cats. 20% of every tag purchase is donated to local animal shelters.',
        },
      ],
    },
  },
  {
    path: '/tags/pet/:petId/style/all',
    alias: ['/tags/pet/:petId/styles', '/tags/pet/:petId/styles/all'],
    name: 'TagsForPet',
    component: Tags,
    props: true,
    meta: {
      title: 'Custom Pet ID Tags, Personalized for Dogs & Cats - DocuPet',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Free shipping on our wide selection of personalized pet ID tags for dogs and cats. 20% of every tag purchase is donated to local animal shelters.',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Custom Pet ID Tags, Personalized for Dogs & Cats - DocuPet',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            'Free shipping on our wide selection of personalized pet ID tags for dogs and cats. 20% of every tag purchase is donated to local animal shelters.',
        },
      ],
    },
  },
  {
    path: '/tags/collection/:id',
    name: 'TagCollection',
    component: Collection,
    meta: {
      titleTemplate: '%s Custom Pet ID Tags - DocuPet',
    },
  },
  {
    path: '/tags/style/:id',
    name: 'Style',
    component: Style,
    meta: {
      titleTemplate: '%s Custom Pet ID Tags - DocuPet',
      showMarketingInfo: true,
    },
  },
  {
    path: '/collars/style/:id',
    name: 'CollarStyle',
    component: CollarStyle,
    props: true,
    meta: {
      titleTemplate: '%s Personalized Collars - DocuPet',
      showMarketingInfo: true,
    },
  },
  {
    path: '/leashes/style/:id',
    name: 'LeashStyle',
    component: LeashStyle,
    props: true,
    meta: {
      titleTemplate: '%s Strong & Functional Leashes - DocuPet',
      showMarketingInfo: true,
    },
  },
  {
    path: '/essentials/group/:groupId/style/:styleId',
    name: 'EssentialStyle',
    component: EssentialStyle,
    props: true,
    meta: {
      titleTemplate: '%s Essentials - DocuPet',
      showMarketingInfo: true,
    },
  },
  {
    path: '/tags/pet/:petId/style/:id',
    name: 'StyleForPet',
    component: Style,
    props: true,
    meta: {
      titleTemplate: '%s Custom Pet ID Tags - DocuPet',
      showMarketingInfo: true
    },
  },
  {
    path: '/wallet-cards',
    name: 'WalletCardStore',
    component: WalletCard,
    props: true,
    meta: {
      title: 'Personalized Wallet Cards for Dogs & Cats - DocuPet',
      meta: [
        { charset: 'utf-8' },
        {
          vmid: 'description',
          name: 'description',
          content:
            'Free shipping on our wide selection of wallet cards for dogs and cats. 20% of every wallet card purchase is donated to local animal shelters.',
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'Personalized Wallet Cards for Dogs & Cats - DocuPet',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content:
            'Free shipping on our wide selection of wallet cards for dogs and cats. 20% of every wallet card purchase is donated to local animal shelters.',
        },
      ],
    },
  },
  {
    path: '/wallet-cards/pet/:petId/style/all',
    name: 'WalletCardStoreForPet',
    component: WalletCard,
    props: true,
    meta: {
      titleTemplate: '%s Pet Identification Cards - Personalized - DocuPet',
    },
  },
  {
    path: '/wallet-cards/pet/:petId/style/:styleId',
    name: 'WalletCardStyle',
    component: WalletCardStyle,
    props: true,
    meta: {
      titleTemplate: '%s Personalized - DocuPet',
    },
  },
  {
    path: '/wallet-cards/style/:styleId',
    name: 'WalletCardProduct',
    component: WalletCardProduct,
    props: true,
    meta: {
      titleTemplate: 'Customize %sWallet Card',
    },
  },
  {
    path: '/assign-product',
    name: 'AssignProduct',
    component: AssignProduct,
  },
  {
    path: '/add-pet',
    name: 'AddPet',
    component: AddPet,
    props: (route) => {
      const props = {};
      Object.keys(route.params).forEach((key) => {
        const camelCaseKey = key.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
        props[camelCaseKey] = route.params[key];
      });
      return props;
    },
  },
  {
    path: '/interrupt',
    name: 'ProductInterrupt',
    component: ProductInterrupt,
  },
  //This is a testing route to test the component.
  {
    path: '/interrupt/_addToOrder',
    name: 'AddToOrder',
    component: AddToOrder,
  },
  // External Symfony URI's
  {
    path: '/basket',
    name: 'Basket',
    beforeEnter: () => {
      window.location.href = `${window.BASE_URL}/${store.getters['getLocale']}/basket`;
    },
  },
  {
    path: '/licensing',
    name: 'ContinueToLicensing',
    beforeEnter: () => {
      window.location.href = `${window.BASE_URL}/${store.getters['getLocale']}/order/licensing/tag-selection`;
    },
  },
  {
    path: '/tags/next',
    name: 'PetTagLoop',
    beforeEnter: () => {
      window.location.href = `${window.BASE_URL}/${store.getters['getLocale']}/tags/next`;
    },
  },
  {
    path: '/admin',
    name: 'AdminRedirect',
    beforeEnter: () => {
      window.location.href = window.APP_PATH.split('/store')[0];
    },
  },
  {
    path: '/smart-tracker',
    name: 'SmartTrackerHomePageRedirect',
    beforeEnter: () => {
      window.location.href = `${window.BASE_URL}/${store.getters['getLocale']}/store/smart-tracker`;
    },
  },
  {
    path: '/pets/:uuid/add-photo',
    name: 'AddPetImage',
    beforeEnter: (to) => {
      let addPetImageUrl = `${window.BASE_URL}/${store.getters['getLocale']}/order/store/add-pet-photo/${to.params.uuid}`;
      if (Object.keys(to.query).length > 0) {
        addPetImageUrl += `?${new URLSearchParams(to.query).toString()}`;
      }
      window.location.replace(addPetImageUrl);
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: global.APP_PATH || process.env.VUE_APP_PATH,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (to.hash && to.hash !== '#/' && to.hash !== '#') {
        return {
          selector: to.hash,
          behaviour: 'smooth',
        };
      } else {
        return { x: 0, y: 0 };
      }
    }
  },
});

router.beforeEach((to, from, next) => {
  const pageTitle = vuei18n.messages[store.getters['getLocale']]?.meta.title?.[to.name] || '';

  document.title = pageTitle ? `DocuPet - ${pageTitle}` : 'DocuPet';
  next();
});

export default router;
